import {gql} from '@apollo/client'
import {useMutation} from 'hooks/graphql'

const START_PROCEDURE_STATUS = gql`
  mutation startProcedureStatus($input: StartProcedureStatusInput!) {
    startProcedureStatus(input: $input) {
      procedureStatus {
        id
      }
    }
  }
`

export interface Variables {
  input: {
    employeeId: string
    procedureType: string
    status: string
    initialized?: boolean
  }
}

export interface Result {
  startProcedureStatus: {
    procedureStatus: {
      id: string
    }
  }
}

export const useStartProcedureStatus = () => useMutation<Result, Variables>(START_PROCEDURE_STATUS)
